import { Box, Stack, Text } from '@chakra-ui/react'
import { ReactNode } from 'react'

interface FieldProps {
  label?: string
  children: ReactNode
  required?: boolean
  error?: string
  helperText?: string
}

export function Field({ label, children, required, error, helperText }: FieldProps) {
  return (
    <Stack gap={1.5}>
      {label && (
        <Text fontWeight="medium" fontSize="sm">
          {label}
          {required && (
            <Text as="span" color="red.500" ml={1}>
              *
            </Text>
          )}
        </Text>
      )}
      <Box>{children}</Box>
      {error && (
        <Text fontSize="sm" color="red.500">
          {error}
        </Text>
      )}
      {helperText && !error && (
        <Text fontSize="sm" color="gray.500">
          {helperText}
        </Text>
      )}
    </Stack>
  )
}
